/**
 * Puente empresa → persona y liquidación única del F22 AT 2026 del empresario individual,
 * régimen 14 D N°3. Junta en un solo resultado el IDPC de su empresa (parte empresa de este
 * módulo) y el IGC de la persona (EmpresarioIndividual/2026/persona), según las
 * instrucciones oficiales del F22 AT 2026:
 * - Línea 54: 18 = código 1440 si es positivo; 20 = IDPC con tasa 12,5 % menos los créditos
 *   del código 19 (este módulo no tiene créditos del recuadro 8: 19 = 0). Exento si la renta
 *   líquida no supera 1 UTA (art. 40 N° 6 LIR): 20 = 0.
 * - Línea 53 (31): IGC de la persona. Línea 85 (36): PPM de la empresa. Línea 92 (54): mayor
 *   retención de sueldos. Línea 97 (757 = 119 + 116): remanentes devolvibles del IGC.
 * - Línea 109: 305 = (líneas 53 a 83 + 106 a 108) − (líneas 84 a 105) = 31 + 20 − 36 − 54 − 757.
 * - Líneas 110 a 112: 85 = 305 negativo en positivo; el 86 (saldo puesto a disposición de los
 *   socios) no corresponde a la EI, así que 87 = 85. Línea 113: 90 = 305 positivo. El
 *   reajuste del art. 72 (39) se conoce en abril y no se calcula, igual que en las empresas.
 *
 * Aparte del 305 unificado está el resultado de la renta de la EMPRESA: IDPC − PPM (los PPM se
 * imputan primero al impuesto de categoría, art. 95 LIR). Es lo único que entra a los asientos
 * de la empresa; el 305 unificado se mezcla con la persona (sueldos, créditos personales).
 */
const formulas = require('./formulas');
const { calcularPersona } = require('../persona/formulas');

const calcularLiquidacion = (d) => {
  const persona = calcularPersona(d);
  const exento = formulas.exentoIDPC(d);
  const c18 = Math.max(formulas.baseImponible.baseImponibleIDPC(d), 0);
  const c19 = 0;
  const c20 = exento ? 0 : Math.max(formulas.baseImponible.idpc(d) - c19, 0);
  const c36 = formulas.baseImponible.ppmActualizado(d) || 0;
  const c757 = persona[119] + persona[116];
  const c305 = persona[31] + c20 - c36 - persona[54] - c757;
  const c85 = Math.max(-c305, 0);
  return {
    exentoIDPC: exento,
    resultadoEmpresa: c20 - c36,
    18: c18, 19: c19, 20: c20,
    31: persona[31], 36: c36, 54: persona[54],
    119: persona[119], 116: persona[116], 757: c757,
    305: c305, 85: c85, 86: 0, 87: c85, 90: Math.max(c305, 0),
  };
};

module.exports = { calcularLiquidacion };
